module.exports = __webpack_public_path__ + "img/medios_pago.5e721089.svg";